var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnInserir)?_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.toInserir()}}},[_vm._v(" Inserir Feriado ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }